import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DogBreedInfo, CatBreedInfo } from './breed-info.model';
import { BreedListComponent } from './breed-list/breed-list.component';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-breeds-info',
  templateUrl: './breeds-info.page.html',
  styleUrls: ['./breeds-info.page.scss'],
})
export class BreedsInfoPage implements OnInit {
  isLoading = false;
  filter = 'dogs';
  dogBreedsList = [];
  catBreedsList = [];
  catImageLoaded = false;
  dogImageLoaded = false;
  selectedDogBreed: DogBreedInfo;
  selectedCatBreed: CatBreedInfo;
  dogRatings: Record<string, string> = {
    stranger_friendly: 'Stranger Friendly',
    dog_friendly: 'Dog Friendly',
    child_friendly: 'Child Friendly',
    energy_level: 'Energy Level',
    barking: 'Barking',
    trainability: 'Trainability',
    shedding_level: 'Shedding Level',
    coat_length: 'Coat Length',
    drooling: 'Drooling',
    playfulness: 'Playfulness',
  };
  catRatings: Record<string, string> = {
    dog_friendly: 'Dog Friendly',
    affection_level: 'Affection Level',
    child_friendly: 'Child Friendly',
    energy_level: 'Energy Level',
    intelligence: 'Intelligence',
    stranger_friendly: 'Stranger Friendly',
    shedding_level: 'Shedding Level',
    vocalisation: 'Vocalisation',
    social_needs: 'Social Needs',
    health_issues: 'Health Issues'
  };

  constructor(private modalCtrl: ModalController, private http: HttpClient) { }

  index: number = 0;
  ngOnInit() {
    this.filter = localStorage.getItem('animalFilter') || 'dogs';
    if (this.filter == 'dogs') { this.loadDogBreeds(); }
    else { this.loadCatBreeds(); }
  }

  loadDogBreeds() {
    if (this.dogBreedsList.length > 0) { return; }
    this.isLoading = true;
    this.http.get<any[]>('assets/dog_breeds.json').subscribe(data => {
      this.dogBreedsList = data;
      this.isLoading = false;
      this.randomizeDogBreed();
    });
  }

  loadCatBreeds() {
    if (this.catBreedsList.length > 0) { return; }
    this.isLoading = true;
    this.http.get<any[]>('assets/cat_breeds.json').subscribe(data => {
      this.catBreedsList = data;
      this.isLoading = false;
      this.randomizeCatBreed();
    });
  }

  onImageLoad() {
    if (this.filter === 'dogs') {
      this.dogImageLoaded = true;
    } else {
      this.catImageLoaded = true;
    }
  }


  randomizeCatBreed() {
    this.isLoading = false;
    if (this.catBreedsList && this.catBreedsList.length > 0) {
      const index = Math.floor(Math.random() * this.catBreedsList.length);
      const listItem = this.catBreedsList[index];
      this.loadSelectedCat(listItem);
      this.isLoading = false;
    }
  }

  randomizeDogBreed() {
    this.isLoading = true;
    if (this.dogBreedsList && this.dogBreedsList.length > 0) {
      const index = Math.floor(Math.random() * this.dogBreedsList.length);
      const listItem = this.dogBreedsList[index];
      this.loadSelectedDog(listItem);
      this.isLoading = false;
    }
  }

  loadSelectedDog(listItem) {
    this.dogImageLoaded = false;
    this.selectedDogBreed = new DogBreedInfo(
      listItem.id,
      listItem.name,
      listItem.description ? listItem.description : '',
      listItem.lifeSpan ? listItem.lifeSpan : '',
      listItem.weightKg ? listItem.weightKg : '',
      listItem.imageUrl ? listItem.imageUrl : '',
      listItem.dog_friendly ? listItem.dog_friendly : '',
      listItem.playfulness ? listItem.playfulness : '',
      listItem.child_friendly ? listItem.child_friendly : '',
      listItem.energy_level ? listItem.energy_level : '',
      listItem.trainability ? listItem.trainability : '',
      listItem.stranger_friendly ? listItem.stranger_friendly : '',
      listItem.shedding_level ? listItem.shedding_level : '',
      listItem.barking ? listItem.barking : '',
      listItem.coat_length ? listItem.coat_length : '',
      listItem.drooling ? listItem.drooling : ''
    );
  }

  loadSelectedCat(listItem) {
    this.catImageLoaded = false;
    this.selectedCatBreed = new CatBreedInfo(
      listItem.id,
      listItem.name,
      listItem.description ? listItem.description : '',
      listItem.lifeSpan ? listItem.lifeSpan : '',
      listItem.temperament ? listItem.temperament : '',
      listItem.origin ? listItem.origin : '',
      listItem.weightKg ? listItem.weightKg : '',
      listItem.imageUrl ? listItem.imageUrl : '',
      listItem.dog_friendly ? listItem.dog_friendly : '',
      listItem.affection_level ? listItem.affection_level : '',
      listItem.child_friendly ? listItem.child_friendly : '',
      listItem.energy_level ? listItem.energy_level : '',
      listItem.intelligence ? listItem.intelligence : '',
      listItem.stranger_friendly ? listItem.stranger_friendly : '',
      listItem.shedding_level ? listItem.shedding_level : '',
      listItem.vocalisation ? listItem.vocalisation : '',
      listItem.social_needs ? listItem.social_needs : '',
      listItem.health_issues ? listItem.health_issues : ''
    );
  }

  selectDogBreed() {
    this.modalCtrl
      .create({
        component: BreedListComponent,
        componentProps: { breedsList: this.dogBreedsList },
      })
      .then((modalEl) => {
        modalEl.present();
        return modalEl.onDidDismiss();
      })
      .then((resData) => {
        if (resData.role === 'select') {
          const breedId = resData.data.breedId;
          const index = this.dogBreedsList.findIndex((b) => b.id === breedId);
          const listItem = this.dogBreedsList[index];
          this.loadSelectedDog(listItem);
        }
      });
  }
  selectCatBreed() {
    this.modalCtrl
      .create({
        component: BreedListComponent,
        componentProps: { breedsList: this.catBreedsList },
      })
      .then((modalEl) => {
        modalEl.present();
        return modalEl.onDidDismiss();
      })
      .then((resData) => {
        if (resData.role === 'select') {
          const breedId = resData.data.breedId;
          const index = this.catBreedsList.findIndex((b) => b.id === breedId);
          const listItem = this.catBreedsList[index];
          this.loadSelectedCat(listItem);
        }
      });
  }
  loadBreeds() {
    localStorage.setItem('animalFilter', this.filter);
    if (this.filter === 'dogs' && this.dogBreedsList.length == 0) {
      this.loadDogBreeds();
    } else if (this.filter === 'cats' && this.catBreedsList.length == 0) {
      this.loadCatBreeds();
    }
  }
  randomizeBreed() {
    if (this.filter === 'dogs') {
      this.randomizeDogBreed();
    } else {
      this.randomizeCatBreed();
    }
  }
  selectBreed() {
    if (this.filter === 'dogs') {
      this.selectDogBreed();
    } else {
      this.selectCatBreed();
    }
  }
  getArray(num: number) {
    return Array(num).fill(0);
  }
}
